module.exports = __webpack_public_path__ + "static/img/bossImg.6ca5fbb9.png";